import React from "react";
import { compose } from "recompose";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";
import LineItems from "./LineItems";
import ContactDetails from "./ContactDetails";
import withData from "./withData";
import HeaderData from "./HeaderData";
import { withSelectedOrganisation } from "../../components/withSelectedOrganisation";
import MainHeader from "./MainHeader";

const DeliveryDetails = ({ item }) => {
  const { DeliveryAddress, AttentionTo, Telephone, DeliveryInstructions } =
    item;
  if (!(DeliveryAddress || AttentionTo || Telephone || DeliveryInstructions))
    return null;
  return (
    <div>
      <hr />
      <h2>
        <Trans>DELIVERY DETAILS</Trans>
      </h2>
      <div className="row">
        <div className="col col-auto">
          <HeaderData
            label="Delivery Address"
            value={DeliveryAddress}
            className="mr-5"
          />
        </div>
        <div className="col col-auto">
          <HeaderData label="Attention" value={AttentionTo} className="mb-2" />
          <HeaderData label="Telephone" value={Telephone} />
        </div>
        <div className="col">
          <HeaderData
            label="Delivery Instructions"
            value={DeliveryInstructions}
          />
        </div>
      </div>
    </div>
  );
};

export const PurchaseOrderDocument = ({
  item,
  contact,
  organisation,
  taxRates,
  settings,
  t,
  ...props
}) => (
  <DocumentRenderer {...props}>
    <div className="container-fluid m-0 p-0">

      <MainHeader item={item} company={contact} client={organisation} taxRates={taxRates} t={t} settings={settings} doc_name={'Purchase Order'} logo={props.selectedOrganisation.logo} hideAttention={true}>
        <HeaderData className="mb-1" label="Date" value={item.DateString} />
        <HeaderData className="mb-1" label="Delivery Date" value={item.DeliveryDateString} />
        <HeaderData className="mb-1" label="Number" value={item.PurchaseOrderNumber}/>
        <HeaderData className="mb-1" label="Reference" value={item.Reference}/>
      </MainHeader>

      <LineItems invoice={item} includeDiscount taxRates={taxRates} />
      <DeliveryDetails item={item} />
    </div>
  </DocumentRenderer>
);

const enhance = compose(withData, withSelectedOrganisation());

export default enhance(PurchaseOrderDocument);
